import StylizedMenuList from './HOClevel'

export default StylizedMenuList
